module.exports = __webpack_public_path__ + "media/images/gift_plan/bubble-img-otoku-01-42aa2f2580e82c847700fe76df92f34a.png";